module.exports = __webpack_public_path__ + "img/benefits-8.23d1edac.svg";